export default __webpack_public_path__ + "static/media/discount-close.7154bae6.svg";